import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CityState, cityFeatureKey } from './city.reducer';

export const getCityState = createFeatureSelector<CityState>(cityFeatureKey);

export const getCityListCurrentProvince = createSelector(getCityState, state => state.cityList);
